import { createI18n } from 'vue-i18n'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

import ar from './langs/ar'
import bn from './langs/bn'
import de from './langs/de'
import en from './langs/en'
import es from './langs/es'
import fr from './langs/fr'
import he from './langs/he'
import hi from './langs/hi'
import id from './langs/id'
import it from './langs/it'
import ja from './langs/ja'
import ko from './langs/ko'
import ms from './langs/ms'
import ptBr from './langs/pt-br'
import ptPt from './langs/pt-pt'
import ru from './langs/ru'
import th from './langs/th'
import vi from './langs/vi'
import zh from './langs/zh'
import zhHant from './langs/zh-Hant'

// 我们系统支持的语言包列表
export const supportedLanguages = [
  'ar',      // 阿拉伯语
  'bn',      // 孟加拉语
  'de',      // 德语
  'en',      // 英语
  'es',      // 西班牙语
  'fr',      // 法语
  'he',      // 希伯来语
  'hi',      // 印地语
  'id',      // 印度尼西亚语
  'it',      // 意大利语
  'ja',      // 日语
  'ko',      // 韩语
  'ms',      // 马来语
  'pt-br',   // 巴西葡萄牙语
  'pt-pt',   // 葡萄牙语
  'ru',      // 俄语
  'th',      // 泰语
  'vi',      // 越南语
  'zh',      // 简体中文
  'zh-Hant', // 繁体中文
];

// 语言映射关系
export const languageMap: { [key: string]: string } = {
  // 默认映射
  default: 'en',

  // 简体中文映射
  'zh': 'zh',
  'zh-Hans': 'zh',
  'zh-Hans-CN': 'zh',
  'zh-Hans-HK': 'zh',
  'zh-Hans-MO': 'zh',
  'zh-Hans-SG': 'zh',
  'zh-CN': 'zh',
  'zh-SG': 'zh',

  // 繁体中文映射
  'zh-Hant': 'zhHant',
  'zh-Hant-HK': 'zhHant',
  'zh-Hant-MO': 'zhHant',
  'zh-Hant-TW': 'zhHant',
  'zh-TW': 'zhHant',
  'zh-HK': 'zhHant',
  'zh-MO': 'zhHant',

  // 英语映射 - 所有英语区域都映射到英语
  'en': 'en',
  'en-US': 'en',
  'en-GB': 'en',
  'en-AU': 'en',
  'en-CA': 'en',
  'en-IN': 'en',
  'en-NZ': 'en',
  'en-ZA': 'en',
  'en-001': 'en',
  // 其他英语变种也映射到英语

  // 西班牙语映射
  'es': 'es',
  'es-ES': 'es',
  'es-AR': 'es',
  'es-BO': 'es',
  'es-CL': 'es',
  'es-CO': 'es',
  'es-CR': 'es',
  'es-DO': 'es',
  'es-EC': 'es',
  'es-GT': 'es',
  'es-HN': 'es',
  'es-MX': 'es',
  'es-NI': 'es',
  'es-PA': 'es',
  'es-PE': 'es',
  'es-PR': 'es',
  'es-PY': 'es',
  'es-SV': 'es',
  'es-UY': 'es',
  'es-VE': 'es',
  'es-419': 'es',

  // 法语映射
  'fr': 'fr',
  'fr-BE': 'fr',
  'fr-CA': 'fr',
  'fr-CH': 'fr',
  'fr-FR': 'fr',
  'fr-LU': 'fr',
  'fr-MC': 'fr',

  // 德语映射
  'de': 'de',
  'de-AT': 'de',
  'de-BE': 'de',
  'de-CH': 'de',
  'de-DE': 'de',
  'de-LI': 'de',
  'de-LU': 'de',

  // 葡萄牙语映射
  'pt': 'ptPt',
  'pt-PT': 'ptPt',
  'pt-BR': 'ptBr',
  'pt-AO': 'ptPt',
  'pt-CV': 'ptPt',
  'pt-GQ': 'ptPt',
  'pt-GW': 'ptPt',
  'pt-LU': 'ptPt',
  'pt-MO': 'ptPt',
  'pt-MZ': 'ptPt',
  'pt-ST': 'ptPt',
  'pt-TL': 'ptPt',

  // 意大利语映射
  'it': 'it',
  'it-CH': 'it',
  'it-IT': 'it',
  'it-SM': 'it',
  'it-VA': 'it',

  // 俄语映射
  'ru': 'ru',
  'ru-BY': 'ru',
  'ru-KG': 'ru',
  'ru-KZ': 'ru',
  'ru-MD': 'ru',
  'ru-RU': 'ru',
  'ru-UA': 'ru',

  // 日语映射
  'ja': 'ja',
  'ja-JP': 'ja',

  // 韩语映射
  'ko': 'ko',
  'ko-KP': 'ko',
  'ko-KR': 'ko',

  // 阿拉伯语映射
  'ar': 'ar',
  'ar-AE': 'ar',
  'ar-BH': 'ar',
  'ar-DZ': 'ar',
  'ar-EG': 'ar',
  'ar-IQ': 'ar',
  'ar-JO': 'ar',
  'ar-KW': 'ar',
  'ar-LB': 'ar',
  'ar-LY': 'ar',
  'ar-MA': 'ar',
  'ar-OM': 'ar',
  'ar-QA': 'ar',
  'ar-SA': 'ar',
  'ar-SY': 'ar',
  'ar-TN': 'ar',
  'ar-YE': 'ar',

  // 印地语映射
  'hi': 'hi',
  'hi-IN': 'hi',

  // 孟加拉语映射
  'bn': 'bn',
  'bn-BD': 'bn',
  'bn-IN': 'bn',

  // 印度尼西亚语映射
  'id': 'id',
  'id-ID': 'id',

  // 泰语映射
  'th': 'th',
  'th-TH': 'th',

  // 越南语映射
  'vi': 'vi',
  'vi-VN': 'vi',

  // 希伯来语映射
  'he': 'he',
  'he-IL': 'he',

  // 马来语映射
  'ms': 'ms',
  'ms-BN': 'ms',
  'ms-MY': 'ms',
  'ms-SG': 'ms',
};

// 语言包映射
const messages = Object.assign({}, {
  ar, 
  bn, 
  de, 
  en, 
  es, 
  fr, 
  he, 
  hi, 
  id, 
  it, 
  ja, 
  ko, 
  ms, 
  ptBr, 
  ptPt, 
  ru, 
  th, 
  vi, 
  zh, 
  zhHant
});

/**
 * 获取匹配的语言
 * @param navigatorLanguage 浏览器语言
 * @returns 匹配的语言代码
 */
export function getLanguage(navigatorLanguage: string): string {
  // 如果传入空值，则返回默认语言
  if (!navigatorLanguage) {
    return languageMap.default;
  }
  
  // 尝试直接匹配完整的语言代码
  if (languageMap[navigatorLanguage]) {
    return languageMap[navigatorLanguage];
  }

  // 尝试匹配语言主体部分（如en-US中的en）
  const mainLang = navigatorLanguage.split('-')[0];
  if (languageMap[mainLang]) {
    return languageMap[mainLang];
  }

  // 如果没有匹配到，返回默认语言（英语）
  return languageMap.default;
}

/**
 * 检查指定语言是否受支持
 * @param lang - 语言代码
 * @returns 是否支持
 */
export function isLanguageSupported(lang: string): boolean {
  return supportedLanguages.includes(lang);
}

/**
 * 获取所有支持的语言列表
 * @returns 支持的语言列表
 */
export function getSupportedLanguages(): Array<string> {
  return [...supportedLanguages];
}

/**
 * 根据指定的语言代码动态加载语言包
 * @param lang - 语言代码
 * @returns 语言包对象的Promise
 */
export async function loadLanguageModule(lang: string): Promise<any> {
  // 如果语言不受支持，使用默认语言(英语)
  const langToUse = isLanguageSupported(lang) ? lang : 'en';
  
  try {
    // 动态导入语言包 - 移除.ts扩展名
    const module = await import(`./langs/${langToUse}`);
    return module.default;
  } catch (error) {
    console.error(`加载语言包失败: ${langToUse}`, error);
    
    // 如果加载失败且不是英语，尝试加载英语包
    if (langToUse !== 'en') {
      try {
        const fallbackModule = await import('./langs/en');
        return fallbackModule.default;
      } catch (fallbackError) {
        console.error('加载备用语言包失败', fallbackError);
      }
    }
    
    // 最终失败时返回一个空对象
    return {};
  }
}

/**
 * 根据浏览器的navigator.language加载相应的语言包
 * @returns 语言包对象的Promise
 */
export async function loadLanguageByNavigator(): Promise<any> {
  // 获取浏览器语言
  const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
  
  // 获取映射后的语言
  const mappedLang = getLanguage(browserLang);
  
  // 动态导入语言包
  return loadLanguageModule(mappedLang);
}

/**
 * 获取用户界面上可选择的语言列表
 * @returns 语言选项列表，包含代码和显示名称
 */
export function getLanguageOptions(): Array<{value: string, label: string}> {
  // 为每种语言提供友好的显示名称
  const languageNames: {[key: string]: string} = {
    'ar': 'العربية',         // 阿拉伯语
    'bn': 'বাংলা',           // 孟加拉语
    'de': 'Deutsch',         // 德语
    'en': 'English',         // 英语
    'es': 'Español',         // 西班牙语
    'fr': 'Français',        // 法语
    'he': 'עברית',           // 希伯来语
    'hi': 'हिन्दी',            // 印地语
    'id': 'Bahasa Indonesia', // 印度尼西亚语
    'it': 'Italiano',        // 意大利语
    'ja': '日本語',           // 日语
    'ko': '한국어',           // 韩语
    'ms': 'Bahasa Melayu',   // 马来语
    'pt-br': 'Português (Brasil)', // 巴西葡萄牙语
    'pt-pt': 'Português (Portugal)', // 葡萄牙语
    'ru': 'Русский',         // 俄语
    'th': 'ไทย',             // 泰语
    'vi': 'Tiếng Việt',      // 越南语
    'zh': '简体中文',         // 简体中文
    'zh-Hant': '繁體中文'     // 繁体中文
  };
  
  // 生成选项列表
  return supportedLanguages.map(lang => ({
    value: lang,
    label: languageNames[lang] || lang
  }));
}

// 本地存储键名
const STORAGE_LANGUAGE_KEY = 'user_language';

/**
 * 保存用户语言选择到本地存储
 * @param lang 语言代码
 */
export function saveUserLanguage(lang: string): void {
  try {
    localStorage.setItem(STORAGE_LANGUAGE_KEY, lang);
  } catch (e) {
    console.error('保存语言选择失败:', e);
  }
}

/**
 * 从本地存储读取用户语言选择
 * @returns 保存的语言代码或null
 */
export function getUserLanguage(): string | null {
  try {
    return localStorage.getItem(STORAGE_LANGUAGE_KEY);
  } catch (e) {
    console.error('读取语言选择失败:', e);
    return null;
  }
}

// 获取用户上次选择的语言或浏览器语言
const savedLanguage = getUserLanguage();
// 默认使用中文，只有在用户明确保存了语言选择时才使用其他语言
const locale = savedLanguage || 'en';

// 创建i18n实例
const i18n = createI18n({
  legacy: false,
  globalInjection: true, // 全局注入 $t, $tc 等函数
  locale: locale, // 使用用户保存的语言或默认为英文
  fallbackLocale: 'en', // 设置回退语言为英文
  messages: {
    ar,
    bn,
    de,
    en,
    es,
    fr,
    he,
    hi,
    id,
    it,
    ja,
    ko,
    ms,
    'pt-br': ptBr,
    'pt-pt': ptPt,
    ru,
    th,
    vi,
    zh,
    'zh-Hant': zhHant
  }
})

/**
 * 创建一个通用的 i18n 消息获取器
 * @param path 消息路径，例如 'Home.FAQ'
 * @returns 当前语言下的消息对象
 */
export function useI18nMessages(path: string) {
  const { locale, messages } = useI18n();
  
  const currentMessages = computed(() => {
    const pathParts = path.split('.');
    let current = (messages.value as any)[locale.value];
    
    for (const part of pathParts) {
      current = current?.[part];
      if (!current) return {};
    }
    
    return current || {};
  });

  return currentMessages;
}

export default i18n